import axios, { getStandardAxiosConfig } from '../../util/api';

class PricingAPI {
  static fetchPricings () {
    return axios.get('/pricings', getStandardAxiosConfig());
  }
  static uploadPricing (pricing) {
    return axios.post(
      '/pricings/' + pricing.id,
      { pricing },
      getStandardAxiosConfig()
    );
  }
  static deletePricing (id) {
    return axios.delete(
      `/pricings/${id}`,
      getStandardAxiosConfig()
    );
  }
}

export default PricingAPI;
